import { IconButton, TextSubtitle, Tooltip } from '@pypestream/design-system';
import { FC } from 'react';

/**
 * The header button that opens and closes the "Ask AI & agents" dock.
 *
 * No tooltip while the dock is open (PSTUDIO-4590): it opens below the
 * button, right over the dock's tab row, and the design system keeps a
 * hovered tooltip open, so a pointer moving from here to the "Agents" tab
 * landed in the tooltip instead. The open dock names itself.
 */
export const SolutionAssistantToggle: FC<{
  open: boolean;
  onToggle: () => void;
}> = ({ open, onToggle }) => {
  const button = (
    <IconButton
      name="stars"
      test-id="ps-solution-assistant-toggle"
      aria-label="Ask AI and configure agents"
      selected={open}
      onClick={onToggle}
    />
  );
  if (open) return button;
  return (
    <Tooltip placement="bottom">
      {button}
      <div slot="content">
        <TextSubtitle size="small">Ask AI &amp; agents</TextSubtitle>
      </div>
    </Tooltip>
  );
};
